export default __webpack_public_path__ + "static/media/home-mobile-hero1.3f0cde02.png";